import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { StarsButton, Toggle, Translation } from '@ps/web-shared-components';
import { StarsInfo, createForm } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import CrmZone from '@swf/components/CrmZone/CrmZone';
import { CRMZone, Country } from '@swf/core/enums';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTCLI_Continue,
  TXTCLI_I_consent_to_receive_details_a_ELL,
  TXTCLI_I_understand_that_I_can_always_ELL,
  TXTCLI_Make_a_Deposit,
  TXTCLI_Verify_account,
  TXTMOB_I_consent_to_receive_details_o_ELL,
  TXTWCL_Pending_the_completion_of_the__ELL,
  TXTWCL_You_may_play_for_fun_now_or_ch_ELL
} from './RegistrationWelcome.messages.json';
import styles from './RegistrationWelcome.scss';

interface FormValues {
  marketingMailList?: boolean;
}

const Form = createForm<FormValues>();

const RegistrationWelcome: React.FC = () => {
  const country = useSelector(select.account.getCountry);
  const license = useSelector(select.account.getLicense);
  const verifyAccount = useFeature(FeatureFlag.VerifyAccount);
  const verifyAccountAfterRmf = useFeature(FeatureFlag.VerifyAccountAfterRmf);
  const accountCreatedContinue = useFeature(FeatureFlag.AccountCreatedContinue);

  const { auth, modal } = useDispatch<Dispatch>();

  const searchParams = useSearchParams<FormValues>();
  const showMarketingMailList = !!(
    Object.keys(searchParams).length && !searchParams.marketingMailList
  );
  const showSendDocumentsNow = verifyAccount && verifyAccountAfterRmf;

  const handleSubmit = async ({ marketingMailList }: FormValues) => {
    if (marketingMailList) {
      await auth.signEula({ marketingMailList, useMailList: true });
    }

    if (!accountCreatedContinue) {
      modal.enqueue({ path: '/account/cashier/deposit' });
    }
    modal.close('/auth/registration/welcome');
  };

  return (
    <Form onSubmit={handleSubmit}>
      {license === LicenceId.EU && country === Country.Netherlands && (
        <StarsInfo className={styles.infoMessage}>
          <Translation {...TXTWCL_Pending_the_completion_of_the__ELL} />{' '}
          <Translation {...TXTWCL_You_may_play_for_fun_now_or_ch_ELL} />
        </StarsInfo>
      )}
      <CrmZone zoneId={CRMZone.SWC_TRANSITION_TO_WC2} componentType="Single" dynamicHeight />
      {showMarketingMailList && (
        <Toggle
          id="marketing"
          type="checkbox"
          name="marketingMailList"
          label={
            license === LicenceId.ITALY
              ? [
                  TXTCLI_I_consent_to_receive_details_a_ELL,
                  TXTCLI_I_understand_that_I_can_always_ELL
                ]
              : TXTMOB_I_consent_to_receive_details_o_ELL
          }
        />
      )}
      <ButtonGroup inline className={classNames({ [styles.buttons]: showSendDocumentsNow })}>
        {showSendDocumentsNow && (
          <StarsButton translation={TXTCLI_Verify_account} href="/account/details/verify-account" />
        )}
        <StarsButton
          type="submit"
          translation={accountCreatedContinue ? TXTCLI_Continue : TXTCLI_Make_a_Deposit}
        />
      </ButtonGroup>
    </Form>
  );
};

export default RegistrationWelcome;
